const REPORT_PATH = '/studentplayground/api/admin/class-attendance/';


function isoDate(date) {
    return date.toISOString().slice(0, 10);
}


export function vilniusWeek(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Vilnius',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).formatToParts(now);
    const value = Object.fromEntries(parts.map(part => [part.type, part.value]));
    const localDate = new Date(Date.UTC(
        Number(value.year),
        Number(value.month) - 1,
        Number(value.day)
    ));
    const daysSinceMonday = (localDate.getUTCDay() + 6) % 7;
    const monday = new Date(localDate);
    monday.setUTCDate(monday.getUTCDate() - daysSinceMonday);
    const sunday = new Date(monday);
    sunday.setUTCDate(sunday.getUTCDate() + 6);
    return { startDate: isoDate(monday), endDate: isoDate(sunday) };
}


export function buildAttendanceReportUrl({
    apiBase = '',
    startDate,
    endDate,
    page = 1,
    pageSize = 50
}) {
    const params = new URLSearchParams({
        start_date: startDate,
        end_date: endDate,
        page: String(page),
        page_size: String(pageSize)
    });
    return `${apiBase}${REPORT_PATH}?${params.toString()}`;
}


export async function fetchAttendanceReport({ fetchImpl = fetch, token, ...query }) {
    const response = await fetchImpl(buildAttendanceReportUrl(query), {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(payload.error || `Failed to load attendance (${response.status}).`);
    }
    return payload;
}
